import React from "react";
import Pill from "components/Pill";
import classnames from "classnames";
import { UI_THEME } from "utils/constants/ui";
import { COLORS } from "utils/styles";
import { NO_OP } from "utils/action";

const DEFAULT_CLASSES = {
  container:
    "flex flex-column w-100 ba br2 pa3 mb3 mb0-ns relative h-100 bg-white"
};

const GridCell = ({
  id,
  label,
  description,
  Icon,
  callout,
  disabled,
  customClasses,
  hideHover,
  isSelected,
  onClick,
  children
}) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const containerProps = {
    className: classnames(`${id} ${classes.container}`, {
      "pointer cell-grow bg-white--hover ba--primary--hover link":
        !disabled && !hideHover,
      "o-90 cursor-not-allowed": disabled,
      "ba--primary": isSelected,
      "hairline-1": !isSelected
    }),
    onClick: onClick && !disabled ? onClick : NO_OP
  };

  return (
    <div {...containerProps}>
      <div className="flex flex-row justify-between items-start">
        <div className="flex flex-row items-center w-100">
          {Icon && <Icon size={20} color={COLORS.primary} />}
          <div
            className={classnames("f4 fw6 color-primary lh-title", {
              pl2: Icon
            })}
            style={{ marginTop: 2 }}
          >
            {label}
          </div>
        </div>
        {callout && <Pill copy={callout} theme={UI_THEME.SLIM} />}
      </div>
      {description && (
        <div className="f6 lh-copy pt2 mt1 color-text--primary">
          {description}
        </div>
      )}
      {children}
    </div>
  );
};

export default GridCell;
